import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("failed"); return; }
        if (attempts < 15) {
          setAttempts((a) => a + 1);
          setTimeout(poll, 2000);
        } else { setStatus("timeout"); }
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <PublicLayout>
      <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
        {status === "pending" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-accent animate-spin mb-6" />
            <h1 className="font-heading font-bold text-2xl">Confirmant el pagament...</h1>
            <p className="text-muted-foreground mt-2 text-sm">No tanquis aquesta finestra.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mb-6">
              <CheckCircle2 className="w-8 h-8" />
            </div>
            <h1 className="font-heading font-bold text-3xl">Pagament confirmat!</h1>
            <p className="text-muted-foreground mt-3">La targeta regal s'ha enviat al correu del destinatari.</p>
            <Button asChild size="lg" className="rounded-full mt-8" data-testid="payment-back-home">
              <Link to="/">Tornar a l'inici</Link>
            </Button>
          </>
        )}
        {(status === "failed" || status === "error" || status === "timeout") && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 text-red-600 flex items-center justify-center mb-6">
              <XCircle className="w-8 h-8" />
            </div>
            <h1 className="font-heading font-bold text-2xl">Hi ha hagut un problema</h1>
            <p className="text-muted-foreground mt-2 text-sm">Torna-ho a intentar o consulta el suport.</p>
            <Button asChild variant="outline" className="rounded-full mt-6">
              <Link to="/targeta-regal">Tornar a la compra</Link>
            </Button>
          </>
        )}
      </div>
    </PublicLayout>
  );
}
